import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ConfigService } from '../../services/config.service';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../core/auth/auth.service';
import { CheckBoxModule, InputsModule } from '@progress/kendo-angular-inputs';
import { DrakeSharedService } from '../../services/drake-shared.service';
import { TranslocoPipe } from '@ngneat/transloco';


@Component({
    selector: 'app-drake-change-password',
    templateUrl: './drake-change-password.component.html',
    styleUrls: ['./drake-change-password.component.scss'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, InputsModule, TranslocoPipe],
    providers: [TranslocoPipe]
})
export class ChangePasswordComponent {
    @Input() baseData: any;
    @Input() scope: string;
    @Input() config: any;
    @Input() titleField: string;
    @Input() descriptionField: string;
    @Input() orderField: string;
    @Input() parentField: string;
    @Input() parentId: string;
    @Input() validationRegex: string;

    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    notification: { message: string, type: string } | null = null;
    showPasswords: boolean = false;
    newPasswordError: string | null = null;
    passwordNotMatchError: string | null = null;

    constructor(private authService: AuthService, private drakeSharedService: DrakeSharedService, private translocoPipe: TranslocoPipe) { }

    validateNewPassword() {
        const regex = new RegExp(this.validationRegex);
        if (!regex.test(this.newPassword) && this.newPassword.length!=0) {
            this.newPasswordError = 'La password deve contenere almeno una maiuscola, una minuscola, 8 caratteri, un numero e un carattere speciale.';
        } else {
            this.newPasswordError = null;
        }

        if (this.newPassword != this.confirmNewPassword && this.newPassword.length != 0 && this.confirmNewPassword.length != 0) {
            this.passwordNotMatchError = 'Le password non coincidono';
        } else {
            this.passwordNotMatchError = null;
        }
    }

    changePassword() {
        this.validateNewPassword();
        if (this.newPasswordError) {
            return;
        }
        if (this.passwordNotMatchError) {
            return;
        }

        /*if (this.newPassword !== this.confirmNewPassword) {
            this.notification = {
                message: 'La nuova password e la conferma della nuova password non coincidono.',
                type: 'error'
            };
            console.log(this.notification.message);
            return;
        }*/

        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userObj = JSON.parse(user);
                const username = userObj.username || '';
                const email = userObj.email || '';

                const passwordData = {
                    username,
                    email,
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword
                };

                this.authService.changePassword(passwordData).subscribe(
                    (response) => {
                        var notification = this.translocoPipe.transform("notification.success.password.modified");
                        this.drakeSharedService.showTemporaryNotification(notification, 'success');
                        console.log(this.notification.message);
                        this.oldPassword = '';
                        this.newPassword = '';
                        this.confirmNewPassword = '';
                    },
                    (error) => {
                        var notification = this.translocoPipe.transform("notification.error.password.notModified");
                        this.drakeSharedService.showTemporaryNotification(notification, 'error');

                        console.error('Error changing password:', error);
                    }
                );
            } catch (error) {
                console.error('Error parsing user JSON:', error);
                this.notification = {
                    message: 'Errore durante il recupero dei dati utente.',
                    type: 'error'
                };
            }
        } else {
            this.notification = {
                message: 'Utente non loggato.',
                type: 'error'
            };
        }
    }

    toggleShowPasswords() {
        this.showPasswords = !this.showPasswords;
    }
}
